import { render } from "./UploadMultiple.vue?vue&type=template&id=0dfb2bd2&ts=true"
import script from "./UploadMultiple.vue?vue&type=script&lang=ts"
export * from "./UploadMultiple.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__